import React from "react";
import Carousel from "nuka-carousel";
import { HashLink as Link } from "react-router-hash-link";
import { Rate } from "antd";
import { feedbackAPI } from "../API/feedbackAPI.js";
import styles from "../feedback.module.css";

import LeftArrow from "./files/leftArrow.js";
import RightArrow from "./files/rightArrow.js";

class FeedbackCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.formFeedback = this.formFeedback.bind(this);
  }

  formFeedback(feedback) {
    const idLink = "/feedback#" + feedback.id;

    return (
      <div className={styles.slideContainer} key={feedback.id}>
        <div
          style={{ display: "flex", minHeight: "11.1em", marginLeft: "1.7%" }}
        >
          <div className={styles.avatarContainer}>
            <img src={feedback.photo} className={styles.avatar} alt="" />
          </div>
          <div className={styles.contentContainer} style={{ flex: "4.8" }}>
            <div style={{ display: "flex" }}>
              <div
                className={styles.quotaContainer}
                style={{
                  alignSelf: "flex-start",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <span style={{ position: "absolute", top: "-5%" }}>«</span>
              </div>
              
                <div style={{ flex: "10", paddingTop: "1em", fontSize: "0.9vw", position: "relative" }}>
                <Link to={idLink}>
                  <div className={styles.textContainer}>
                    <div dangerouslySetInnerHTML={{ __html: feedback.text }} />
                  </div>
                  </Link>
                </div>
              
              <div
                className={styles.quotaContainer}
                style={{
                  alignSelf: "flex-end"
                }}
              >
                <span style={{ position: "absolute", top: "34.5%" }}>»</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", paddingTop: "1em", fontSize: "0.9vw" }}>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "4.8" }}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: "1" }} />
              <div style={{ flex: "10" }}>
                <div className={styles.scoreContainer}>
                  <Rate
                    disabled
                    defaultValue={feedback.score}
                    style={{ color: "#fca25c" }}
                  />
                </div>
                <div style={{ fontWeight: "600" }}>
                  <span>{feedback.name}</span> <span>—</span>{" "}
                  <span>{feedback.occupation}</span>
                </div>
              </div>
              <div style={{ flex: "0" }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let feedbacks = [];
    feedbackAPI.map((object, i) => feedbacks.push(this.formFeedback(object)));

    return (
      <Carousel
        style={{ height: "100%" }}
        autoplay={false}
        autoplayInterval={4500}
        speed={200}
        wrapAround={true}
        transitionMode="fade"
        renderBottomCenterControls={null}
        dragging={false}
        renderCenterLeftControls={({ previousSlide }) => (
          <div className={styles.arrowLeft} onClick={previousSlide}>
            <LeftArrow />
          </div>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <div className={styles.arrowRight} onClick={nextSlide}>
            <RightArrow />
          </div>
        )}
      >
        {feedbacks}
      </Carousel>
    );
  }
}

export default FeedbackCarousel;
